"use strict";

var _regeneratorRuntime = require("/opt/build/repo/overall-web-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _ModalContent = _interopRequireDefault(require("./ModalContent"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var Modal = /*#__PURE__*/function (_Component) {
  _inherits(Modal, _Component);

  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Modal).call(this, props));
    _this.state = {
      closeAnime: false
    };
    return _this;
  }

  _createClass(Modal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          onClose = _this$props.onClose,
          preventDefaultClose = _this$props.preventDefaultClose,
          centerPositioning = _this$props.centerPositioning,
          position = _this$props.position,
          showArrow = _this$props.showArrow,
          arrowPosition = _this$props.arrowPosition,
          modalShadow = _this$props.modalShadow,
          modalBorder = _this$props.modalBorder,
          modalBorderRadius = _this$props.modalBorderRadius,
          modalBackground = _this$props.modalBackground,
          backgroundMaskColor = _this$props.backgroundMaskColor,
          customZIndex = _this$props.customZIndex,
          animation = _this$props.animation,
          animeType = _this$props.animeType,
          animeDuration = _this$props.animeDuration,
          animatedClose = _this$props.animatedClose;
      var closeAnime = this.state.closeAnime;
      return React.createElement("div", {
        className: "gib-r-drpd-m-_ModalMask ".concat(centerPositioning && 'gib-r-drpd-m-_ModalMask-m-centered'),
        style: {
          background: backgroundMaskColor ? backgroundMaskColor : 'rgba(1, 1, 1, 0)',
          zIndex: customZIndex ? customZIndex : 20,
          animation: closeAnime || animatedClose ? "".concat(animeType, "_rev ").concat(animeDuration, "ms normal forwards ease-in-out") : "".concat(animeType, " ").concat(animeDuration, "ms normal forwards ease-in-out")
        },
        onClick: function onClick(e) {
          e.stopPropagation();

          if (!preventDefaultClose) {
            _this2.setState({
              closeAnime: true
            });

            setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return _this2.setState({
                        closeAnime: false
                      });

                    case 2:
                      onClose();

                    case 3:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, this);
            })), animeDuration);
          }
        }
      }, React.createElement("div", {
        className: "gib-r-drpd-m-_Modal",
        style: {
          background: modalBackground ? modalBackground : 'white',
          borderRadius: modalBorderRadius ? modalBorderRadius : '0px',
          left: !centerPositioning && position.left ? position.left : 'auto',
          right: !centerPositioning && position.right ? position.right : 'auto',
          top: !centerPositioning && position.top ? position.top : 'auto',
          bottom: !centerPositioning && position.bottom ? position.bottom : 'auto',
          animation: closeAnime || animatedClose ? "".concat(animeType, "_child_rev ").concat(animeDuration, "ms normal forwards ease-in-out") : "".concat(animeType, "_child ").concat(animeDuration, "ms normal forwards ease-in-out"),
          border: modalBorder === true ? '1px solid #bbbbbb' : modalBorder ? modalBorder : '0px solid white',
          boxShadow: modalShadow === true ? '0px 0px 10px 0px rgba(0,0,0,0.2)' : modalShadow ? modalShadow : '0px 0px 0px 0px rgba(0,0,0,0)'
        }
      }, React.createElement(_ModalContent.default, this.props)));
    }
  }]);

  return Modal;
}(React.Component);

var _default = Modal;
exports.default = _default;